export const FallOfTheIceCream: React.FC<React.HTMLProps<SVGSVGElement>> = (props) => (
  <svg
    width={198}
    height={198}
    viewBox="0 0 198 198"
    xmlns="http://www.w3.org/2000/svg"
    role="none"
    {...props}
  >
    <defs>
      <path id="e1byfektla" d="M0 125.871L147.793 125.871 147.793 0.707 0 0.707z" />
      <path
        id="8q4zk1vfrc"
        d="M48.792 16.592L0.707 40.194 25.001 64.294 49.295 88.393 73.087 40.692 89.1 8.588 81.157 0.707"
      />
      <path
        id="z3869ghxpe"
        d="M48.792 16.592L0.707 40.194 25.001 64.294 49.295 88.393 73.087 40.692 89.1 8.588 81.157 0.707"
      />
      <path
        id="415ydobfhg"
        d="M48.792 16.592L0.707 40.194 25.001 64.294 49.295 88.393 73.087 40.692 89.1 8.588 81.157 0.707"
      />
      <path
        id="umwm8h44vi"
        d="M48.792 16.592L0.707 40.194 25.001 64.294 49.295 88.393 73.087 40.692 89.1 8.588 81.157 0.707"
      />
      <path
        id="dh999cnbak"
        d="M48.792 16.592L0.707 40.194 25.001 64.294 49.295 88.393 73.087 40.692 89.1 8.588 81.157 0.707"
      />
      <path
        id="jv7hfqid9m"
        d="M48.792 16.592L0.707 40.194 25.001 64.294 49.295 88.393 73.087 40.692 89.1 8.588 81.157 0.707"
      />
      <path
        id="91mtt0dyno"
        d="M48.792 16.592L0.707 40.194 25.001 64.294 49.295 88.393 73.087 40.692 89.1 8.588 81.157 0.707"
      />
      <path
        id="skaezlp8eq"
        d="M48.792 16.592L0.707 40.194 25.001 64.294 49.295 88.393 73.087 40.692 89.1 8.588 81.157 0.707"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g>
        <g>
          <g>
            <g transform="translate(-585 -419) translate(585 419) translate(26.871 32.529) translate(0 .707)">
              <path
                fill="#FFD6C9"
                d="M63.966 92.355c-9.942 9.803-26.06 9.803-36.002 0-9.942-9.803-9.942-25.698 0-35.502 9.942-9.804 26.06-9.804 36.002 0 9.94 9.804 9.94 25.699 0 35.502"
              />
              <path
                fill="#FF5636"
                d="M85.18 114.276c-9.942 9.803-26.06 9.803-36.003 0-9.94-9.804-9.94-25.698 0-35.502 9.942-9.803 26.06-9.803 36.003 0 9.941 9.804 9.941 25.698 0 35.502"
              />
              <path
                fill="#FFCE32"
                d="M133.65 17.136L125.706 9.193 93.343 25.206 45.257 48.998 69.551 73.292 93.845 97.586 117.637 49.5z"
              />
              <path
                fill="#BF3939"
                d="M62.21 121.629c4.069-9.234 2.337-20.417-5.21-27.983-9.805-9.833-25.702-9.833-35.508 0-7.546 7.566-9.278 18.749-5.21 27.983H62.21z"
              />
              <mask id="iudn3tw6kb" fill="#fff">
                <use xlinkHref="#e1byfektla" />
              </mask>
              <path
                fill="#BF3939"
                d="M0 125.871L111.021 125.871 111.021 120.214 0 120.214z"
                mask="url(#iudn3tw6kb)"
              />
            </g>
            <g>
              <g transform="translate(-585 -419) translate(585 419) translate(26.871 32.529) translate(44.55 8.486)">
                <mask id="2g67m76sud" fill="#fff">
                  <use xlinkHref="#8q4zk1vfrc" />
                </mask>
                <path
                  stroke="#F8FBCF"
                  strokeWidth="2"
                  d="M16.618 -7.779L16.618 96.879"
                  mask="url(#2g67m76sud)"
                />
              </g>
              <g transform="translate(-585 -419) translate(585 419) translate(26.871 32.529) translate(44.55 8.486)">
                <mask id="1ixcv4djof" fill="#fff">
                  <use xlinkHref="#z3869ghxpe" />
                </mask>
                <path
                  stroke="#F8FBCF"
                  strokeWidth="2"
                  d="M39.246 -7.779L39.246 96.879"
                  mask="url(#1ixcv4djof)"
                />
              </g>
              <g transform="translate(-585 -419) translate(585 419) translate(26.871 32.529) translate(44.55 8.486)">
                <mask id="o6hcctc47h" fill="#fff">
                  <use xlinkHref="#415ydobfhg" />
                </mask>
                <path
                  stroke="#F8FBCF"
                  strokeWidth="2"
                  d="M61.168 -7.779L61.168 96.879"
                  mask="url(#o6hcctc47h)"
                />
              </g>
              <g transform="translate(-585 -419) translate(585 419) translate(26.871 32.529) translate(44.55 8.486)">
                <mask id="8hnl1njgwj" fill="#fff">
                  <use xlinkHref="#umwm8h44vi" />
                </mask>
                <path
                  stroke="#F8FBCF"
                  strokeWidth="2"
                  d="M84.504 -7.779L84.504 96.879"
                  mask="url(#8hnl1njgwj)"
                />
              </g>
              <g transform="translate(-585 -419) translate(585 419) translate(26.871 32.529) translate(44.55 8.486)">
                <mask id="6hp8o1z18l" fill="#fff">
                  <use xlinkHref="#dh999cnbak" />
                </mask>
                <path
                  stroke="#F8FBCF"
                  strokeWidth="2"
                  d="M103.243 10.254L-2.121 10.254"
                  mask="url(#6hp8o1z18l)"
                />
              </g>
              <g transform="translate(-585 -419) translate(585 419) translate(26.871 32.529) translate(44.55 8.486)">
                <mask id="ut7d1slejn" fill="#fff">
                  <use xlinkHref="#jv7hfqid9m" />
                </mask>
                <path
                  stroke="#F8FBCF"
                  strokeWidth="2"
                  d="M103.243 32.882L-2.121 32.882"
                  mask="url(#ut7d1slejn)"
                />
              </g>
              <g transform="translate(-585 -419) translate(585 419) translate(26.871 32.529) translate(44.55 8.486)">
                <mask id="0353bajehp" fill="#fff">
                  <use xlinkHref="#91mtt0dyno" />
                </mask>
                <path
                  stroke="#F8FBCF"
                  strokeWidth="2"
                  d="M103.243 54.804L-2.121 54.804"
                  mask="url(#0353bajehp)"
                />
              </g>
              <g transform="translate(-585 -419) translate(585 419) translate(26.871 32.529) translate(44.55 8.486)">
                <mask id="fvo03f28jr" fill="#fff">
                  <use xlinkHref="#skaezlp8eq" />
                </mask>
                <path
                  stroke="#F8FBCF"
                  strokeWidth="2"
                  d="M103.243 78.139L-2.121 78.139"
                  mask="url(#fvo03f28jr)"
                />
              </g>
            </g>
            <g>
              <path
                fill="#FF5636"
                d="M94.927 7.254L72.48 29.7l-6.009-6.01L88.917 1.245c1.66-1.66 4.35-1.66 6.01 0 1.66 1.66 1.66 4.35 0 6.01"
                transform="translate(-585 -419) translate(585 419) translate(26.871 32.529) translate(4.243 57.986)"
              />
              <path
                fill="#BF3939"
                d="M59.57 46.65s3.747 15.616 16.84 15.616c10.443 0 4.807 4.205 4.807 4.205H0v-4.205s10.005-2.87 10.005-10.265c6.016-6.104 24.802-6.556 27.289-5.715 2.486.842 22.276.365 22.276.365"
                transform="translate(-585 -419) translate(585 419) translate(26.871 32.529) translate(4.243 57.986)"
              />
              <path
                fill="#BF3939"
                d="M81.4 62.464c5.003 0 5.837-5.185 10.84-5.185 5.002 0 5.716 5.185 8.694 5.185 2.56 2.654-1.191 2.593-1.191 2.593H85.569s-9.171-2.593-4.169-2.593"
                transform="translate(-585 -419) translate(585 419) translate(26.871 32.529) translate(4.243 57.986)"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
